import { useQuery } from 'react-query';

import { getUserAccountBody } from '../../size-recommendation/graphql/user-account-body.2';

export const GET_USER_ACCOUNT_BODY_QUERY_KEY = ['GetUserAccountBody'];

const fetchUserAccountBody = async () => {
  const { data } = await getUserAccountBody();
  return data;
};

export const useGetUserAccountBodyQuery = (options?: { enabled?: boolean }) => {
  return useQuery(GET_USER_ACCOUNT_BODY_QUERY_KEY, fetchUserAccountBody, {
    // 체형 입력 후 바로 반영되어야 하므로 staleTime을 짧게 가져가거나 0으로 설정
    staleTime: 0,
    enabled: options?.enabled,
  });
};
